import { cx } from "@emotion/css";
import React, { FunctionComponent } from "react";

import { useTheme } from "@/modules/theme/hooks/useTheme";

import { createTypographyStyles } from "./helpers/createTypographyStyles";

type TypographyProps = {
  className?: string;
  variant:
    | "pageHeading"
    | "heading"
    | "headingLarge"
    | "subheading"
    | "contentLarge"
    | "contentSmall"
    | "contentMedium";
  Component?: React.ElementType;
};

const getVariantComponent = (variant: TypographyProps["variant"]) => {
  switch (variant) {
    case "pageHeading":
    case "heading":
    case "headingLarge":
      return "h1";
    case "subheading":
      return "h2";
    default:
      return "p";
  }
};

export const Typography: FunctionComponent<TypographyProps> = ({
  variant,
  className,
  children,
  Component,
}) => {
  const HtmlElement = Component || getVariantComponent(variant);
  const theme = useTheme();
  const classes = createTypographyStyles(theme);
  return (
    <HtmlElement className={cx(classes.root, classes[variant], className)}>
      {children}
    </HtmlElement>
  );
};
